<template>
    <div :id="dialogId"
         class="modal fade"
         tabindex="-1"
         role="dialog"
         :aria-labelledby="titleId"
         aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered dialog-wide">
            <div class="modal-content">
                <div class="modal-header">
                    <label :id="titleId"
                           class="modal-title">
                        <label>
                            <i :class="iconClass" />
                            <span> {{ title }}</span>
                        </label>
                    </label>
                </div>
                <div class="modal-body no-padding left-align">
                    <div>
                        {{ body }}
                    </div>
                </div>
                <br>
                <div class="modal-footer">
                    <button type="button"
                            class="btn btn-primary btn-sm btn-dark-color"
                            @click="close">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { modalDialog } from '../js/ModalDialog.js';

    export default {
        name: 'SimpleDialog',
        props: {
            dialogId: {
                type: String,
                default: 'modal-dialog'
            },
            icon: {
                type: String,
                default: ''
            },
            title: {
                type: String,
                default: ''
            },
            body: {
                type: String,
                default: ''
            },
        },
        expose: ['open', 'close'],
        data: () => {
            return {
            }
        },
        computed: {
            iconClass: function () {
                return (this.icon) ? `icon ${this.icon}` : '';
            },
            titleId: function () {
                return `${this.dialogId}-title`;
            }

        },
        mounted: function () {
            modalDialog.init(this.dialogId);
        },
        methods: {
            open: function () {
                modalDialog.openModal(this.dialogId);
            },
            close: function () {
                modalDialog.closeModal(this.dialogId);
            },
        },
    }

</script>

<style scoped>
</style>